/* 布局 */
//前台
import Layout from "@views/layout";

const bannerRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "banner",
            name: "BANNER",
            meta: {
                title: "banner管理",
                sort: 1,
            },
            component: () => import("@views/business/banner/index.vue"),
            redirect: {
                name: "BANNER_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "BANNER_LIST",
                    meta: {
                        title: "banner管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/banner/list.vue"),
                },
                                {
                    path: "add",
                    name: "BANNER_ADD",
                    meta: {
                        title: "新增banner图表",
                        parentPath: '/business/banner/list',
                        operate: true,
                    },
                    component: () => import("@views/business/banner/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "BANNER_EDIT",
                    meta: {
                        title: "编辑banner图表",
                        parentPath: '/business/banner/list',
                        operate: true,
                    },
                    component: () => import("@views/business/banner/form.vue"),
                },
                                        ],
    },


        ],
};

export default bannerRouter;
